module.exports = {
  channelName: 'Tên kênh',
  simQueryPlaceholder: 'Vui lòng nhập tên kênh',
  shippingType: 'Phương thức vận chuyển',
  destinationDistribution: 'Phương thức giao hàng tại điểm đến',
  chargingMethod: 'Phương thức tính phí',
  acceptableGoods: 'Loại hàng hóa nhận',
  settlementWeightRoundingRules: 'Quy tắc làm tròn trọng lượng thanh toán',
  creator: 'Người tạo',
  bubbleCountingRatio: 'Hệ số tính thể tích',
  bubbleSplittingRatio: 'Tỷ lệ chia thể tích',
  multipleBoxesCalculationRules: 'Quy tắc tính nhiều kiện',
  singleBoxLowestBillableWeight: 'Trọng lượng tính phí tối thiểu mỗi kiện',
  newChannel: 'Thêm kênh mới',
  editChannel: 'Chỉnh sửa kênh',
  lookChannel: 'Xem kênh',
  weightInfo: 'Thông tin tính trọng lượng',
  channelNameNoEmpty: 'Tên kênh không được để trống!',
  shippingTypeNoEmpty: 'Phương thức vận chuyển không được để trống!',
  destinationDistributionNoEmpty: 'Phương thức giao hàng tại điểm đến không được để trống!',
  chargingMethodNoEmpty: 'Phương thức tính phí không được để trống!',
  bubbleCountingRatioNoEmpty: 'Hệ số tính thể tích không được để trống!',
  bubbleSplittingRatioNoEmpty: 'Tỷ lệ chia thể tích không được để trống!',
  singleBoxLowestBillableWeightNoEmpty: 'Trọng lượng tính phí tối thiểu mỗi kiện không được để trống!',
  multipleBoxesCalculationRulesNoEmpty: 'Quy tắc tính nhiều kiện không được để trống!',
  settlementWeightRoundingRulesNoEmpty: 'Quy tắc làm tròn trọng lượng thanh toán không được để trống!',
  acceptableGoodsNoEmpty: 'Vui lòng chọn ít nhất một loại hàng hóa nhận!',
  editExistChannel: 'Kênh đã tạo báo giá, có làm mới thông tin kênh trong báo giá không?',
  notEditName: 'Kênh này đã được dùng trong báo giá, không thể sửa tên kênh.',
  activeState: 'Trạng thái kích hoạt',
  enable: 'Kích hoạt',
  disable: 'Vô hiệu hóa',
  enableSucceed: 'Kích hoạt kênh thành công!',
  disableSucceed: 'Vô hiệu hóa kênh thành công!',
  cannotActive: 'Không có dữ liệu để chỉnh sửa.',
  cannotDelete: 'Không được phép xóa kênh đã tạo báo giá!'
}
